import { isAfter, isSameDay, parseISO } from 'date-fns';

export function isAfterCurrentMonth(dateString: string | null | undefined): boolean {
    if (!dateString) return false;
    const date = parseISO(dateString);
    const now = new Date();
    const startOfNextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
    return isSameDay(startOfNextMonth, date) || isAfter(date, startOfNextMonth);
}
